import { applicationTypes } from '../models/common.ts'
import { vObject, type vOutput, vPicklist } from '../validation/index.ts'

export const liveResetSchema = vObject({
  application: vPicklist(applicationTypes),
})

export type LiveResetDTO = vOutput<typeof liveResetSchema>

export const deployHookSchema = vObject({
  app: vPicklist(['carrier', 'shipper', 'admin']),
})

export type DeployHookDTO = vOutput<typeof deployHookSchema>
